import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=6ee3358d&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=6ee3358d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee3358d",
  null
  
)

export default component.exports